import React from "react";
import PdfReportsOverview from "../../Components/PdfReportsComponents/PdfReportsOverview";

const PdfReportsPage = () => {
  return <PdfReportsOverview />;
};

export default PdfReportsPage;
